
export default {
  props: {
    content: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    refProp: {
      type: Object,
      default: () => {}
    },
    isMenuBookTooltip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      anchorElement: null,
      offsetX: 0,
      offsetY: 0,
      anchorHeight: 0,
      anchorWidth: 0
    };
  },
  created() {
    window.addEventListener("resize", this.calculatePosition);
  },
  beforeMount() {
    this.anchorElement = this.refProp;

    // check if ref is a Vue component
    if (this.refProp?._isVue) {
      this.anchorElement = this.refProp.$el;
    }

    this.calculatePosition();
  },
  methods: {
    calculatePosition() {
      if (this.anchorElement) {
        this.offsetX = this.anchorElement.getBoundingClientRect().x;
        this.offsetY = this.anchorElement.getBoundingClientRect().bottom;
        this.anchorHeight = this.anchorElement.getBoundingClientRect().height;
        this.anchorWidth = this.anchorElement.getBoundingClientRect().width;
      }
    },
    handleClick() {
      this.$emit("tooltip-clicked");
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.calculatePosition);
  }
};
